import { createStyles, makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import { JupiterTheme } from '../../theme/types';
import CircularProgress from '@material-ui/core/CircularProgress';
const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    logoProgressContainer: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
  })
);

interface Props {
  'data-testid'?: string;
  className?: string;
  size?: number;
}

const LogoProgress = ({
  className,
  'data-testid': dataTestId = 'logo-progress',
  size = 40,
}: Props) => {
  const classes = useStyles();

  return (
    <div
      aria-live="polite"
      aria-busy="true"
      data-testid={'logo-progress'}
      className={clsx(classes.logoProgressContainer, className)}
    >
      <CircularProgress size={size} color="primary" />
    </div>
  );
};

export default LogoProgress;
